import { Observable } from 'rxjs'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { BaseModal } from './base-modal'
import { ModalEditMode } from '../../modals'
import { IModalEditOptions } from './i-modal-edit-options'

export abstract class RepositoryModal<T> extends BaseModal {
    protected editOptions!: IModalEditOptions<T>
    faSpinner = faSpinner

    public initialize(editOptions: IModalEditOptions<T>) {
        this.editOptions = editOptions
        this.onInitialized()
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected onInitialized(): void {}

    public get isAdding(): boolean {
        return this.editOptions.mode == ModalEditMode.adding
    }

    public get isEditing(): boolean {
        return this.editOptions.mode == ModalEditMode.editing
    }

    public get isImporting(): boolean {
        return this.editOptions.mode == ModalEditMode.importing
    }

    public get isDuplicating(): boolean {
        return this.editOptions.mode == ModalEditMode.duplicating
    }

    public get target(): T {
        return this.editOptions.target
    }

    public get title(): string {
        let title = ''
        if (this.isAdding) {
            title = 'New {0}'
        } else if (this.isEditing) {
            title = 'Edit {0}'
        } else if (this.isDuplicating) {
            title = 'Duplicate {0}'
        } else if (this.isImporting) {
            title = 'Import {0}'
        }

        return title.format(this.editOptions.typeName)
    }

    protected repositoryEdit(): Observable<any> {
        return this.editOptions.repository.edit(this.target)
    }

    protected repositoryAdd(): Observable<any> {
        return this.editOptions.repository.add(this.target)
    }

    protected onError(errorResult: any) {
        if (errorResult.status && errorResult.status == 400) {
            const responseBody = errorResult.error
            const bodyText =
                typeof responseBody === 'string' && responseBody.trim().length !== 0 ? responseBody : errorResult.statusText
            if (bodyText && bodyText.length != 0) {
                this.services.modals.warning('Cannot Save', bodyText)
                return
            }
        }

        this.services.notification.error('Failed to save changes.')
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        let observable: Observable<any>

        if (this.isAdding || this.isDuplicating) {
            observable = this.repositoryAdd()
        } else {
            observable = this.repositoryEdit()
        }

        observable.subscribe(
            successResult => {
                resolveSave(successResult)
            },
            errorResult => {
                rejectSave(errorResult)
            },
        )
    }
}
